export default "__VITE_ASSET__0re9PU2___"